import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Container,
  Alert,
  Link
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import httpClient from '../../utils/httpClient';

const ResetPasswordConfirm: React.FC = () => {
  const [passwordRaw, setPasswordRaw] = useState('');
  const [passwordRawConfirmed, setPasswordRawConfirmed] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const validate = (): boolean => {
    if (!passwordRaw || !passwordRawConfirmed) {
      setError('Por favor, preencha todos os campos.');
      return false;
    }
    if (passwordRaw.length > 15 || passwordRawConfirmed.length > 15) {
      setError('A senha deve ter no máximo 15 caracteres.');
      return false;
    }
    if (passwordRaw !== passwordRawConfirmed) {
      setError('As senhas não coincidem.');
      return false;
    }
    if (!token) {
      setError('Token inválido ou ausente.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validate()) return;

    try {
      const res = await httpClient.post(
        '/api/v1/portal/authentication/reset-password-request-confirmed',
        {
          resetPassworkToken: token,
          passwordRaw: passwordRaw,
          passwordRawConfirmed: passwordRawConfirmed
        },
        { headers: { 'X-Skip-Auth': 'true' } }
      );

      const payload = res?.data;
      const isOk = (typeof payload === 'boolean' && payload === true) || (payload?.success === true && Number(payload?.status) === 200 && payload?.data === true);

      if (isOk) {
        setMessage('Senha atualizada com sucesso! Você será redirecionado para o login.');
        setTimeout(() => navigate('/login'), 2500);
      } else {
        const errors = Array.isArray(payload?.errors) ? payload.errors : [];
        const firstErrorMessage = errors[0]?.errorMessage || 'Falha na confirmação de redefinição de senha.';
        setError(firstErrorMessage);
      }
    } catch (err: any) {
      const respData = err?.response?.data;
      let apiError = '';
      if (respData) {
        if (Array.isArray(respData.errors) && respData.errors.length > 0) {
          apiError = respData.errors[0]?.errorMessage || '';
        } else if (typeof respData.message === 'string') {
          apiError = respData.message;
        }
      }
      setError(apiError || 'Erro ao confirmar redefinição de senha.');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
            width: '100%',
          }}
        >
          <Typography component="h1" variant="h5" color="primary" sx={{ fontWeight: 'bold', mb: 3 }}>
            Redefinição de Senha
          </Typography>

          {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{message}</Alert>}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Informe sua nova senha para concluir a redefinição.
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="new-password"
              label="Nova Senha"
              name="new-password"
              type="password"
              inputProps={{ maxLength: 15 }}
              value={passwordRaw}
              onChange={(e) => setPasswordRaw(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="confirm-password"
              label="Confirmação da Senha"
              name="confirm-password"
              type="password"
              inputProps={{ maxLength: 15 }}
              value={passwordRawConfirmed}
              onChange={(e) => setPasswordRawConfirmed(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: 'primary.main' }}
            >
              Confirmar
            </Button>
            <Box sx={{ textAlign: 'center' }}>
              <Link href="/login" variant="body2">
                Voltar para o login
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetPasswordConfirm;